import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CURRENT_LANG } from '../config';

const checkPureText = (html) => {
	const tmp = document.createElement("div");
	tmp.innerHTML = html;
	return tmp.innerText.trim().length;
}

const BigTextInner = ({lang, k, replace=[]}) => {
	const [ body, set_body ] = useState(null);
	const [ failed, set_failed ] = useState(false);
	const [ language, set_language ] = useState(lang);

	// TODO XXX These texts needs to go to another s3 if no access to Zwedit. They've all been added to bigtext/ directory in this git.
	useEffect(() => {
		const url = "https://zwedit.s3.eu-north-1.amazonaws.com/b/pentus/b." + k + "." + language + ".html?v=3453454";
		axios.get(url, { responseType: "text" }).then(x => {
			if (x.status === 200) {
				if(checkPureText(x.data)) {
					set_body(x.data);
				} else {
					if(language !== 'en') {
						set_language('en');
					}
				}
			} else {
				set_failed(true);
			}
		}).catch(e => {
			set_failed(true);
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lang, k]);

	 
	let r = <span>...</span>; // XXX allow custom loader?
	 
	if (failed) {
		r = <span data-error="could not fetch document"></span>; // XXX allow custom "not found" message?
	} else if (body !== null) {
		let neu_kopf = body;
		if(replace.length) {
			replace.forEach( (serep) => {
				if(serep.src) {
					neu_kopf = neu_kopf.replaceAll(serep.src, serep.dst);
				}
			});
		}
		r = <div dangerouslySetInnerHTML={{__html:neu_kopf}}></div>;
	}
	return r;
}

const BigText = ({k, ...props}) => {
	let lang = CURRENT_LANG;
	if (!lang) return <span></span>;
	return (
		<BigTextInner
			k={k}
			lang={lang}
			{...props}
		/>
	)
};

export default BigText;
